import { ReactNode } from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { BookOpen, Mail, Sparkles } from "lucide-react";

type HelpMenuProps = {
  /** The trigger's content — the "Help and Support" drawer row. */
  children: ReactNode;
  /** The trigger's classes (a drawer row). */
  className?: string;
  onFaq: () => void;
  onContactUs: () => void;
  onAskModern: () => void;
};

const ITEM =
  "flex w-full cursor-pointer items-center gap-2 rounded-lg px-3 py-2.5 text-left text-sm font-medium text-gray-800 hover:bg-gray-100 data-[focus]:bg-gray-100 data-[focus]:text-gray-900";

/**
 * The mini menu that opens off the drawer's "Help and Support" row (in-game
 * parity, client 2026-10-08): the FAQ, Contact Us, and "Chat Support" — the
 * support assistant. It floats beside the drawer, above it (the drawer layer
 * is 99990), like the drawer's app picker.
 */
export function HelpMenu({ children, className, onFaq, onContactUs, onAskModern }: HelpMenuProps) {
  return (
    <Menu>
      <MenuButton as="div" role="button" tabIndex={0} className={className}>
        {children}
      </MenuButton>
      <MenuItems
        anchor="right end"
        modal={false}
        className="z-[99991] w-56 rounded-xl border border-gray-200 bg-white p-1.5 text-gray-900 shadow-2xl [--anchor-gap:10px] focus:outline-none"
      >
        <MenuItem>
          <button type="button" onClick={onFaq} className={ITEM}>
            <BookOpen className="h-4 w-4 text-gray-500" />
            FAQ
          </button>
        </MenuItem>
        <MenuItem>
          <button type="button" onClick={onContactUs} className={ITEM}>
            <Mail className="h-4 w-4 text-gray-500" />
            Contact Us
          </button>
        </MenuItem>
        <MenuItem>
          <button type="button" onClick={onAskModern} className={ITEM}>
            <Sparkles className="h-4 w-4 text-gray-500" />
            Chat Support
          </button>
        </MenuItem>
      </MenuItems>
    </Menu>
  );
}
